import { ShieldOff, BookLock, Shield, UserCheck } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const invariants = [
  { icon: ShieldOff, title: 'Zero-Fact Policy', body: 'LINK never creates clinical facts or suggests "extra" procedures.' },
  { icon: BookLock, title: 'Immutable Audit Logs', body: 'Every decision has a permanent, unchangeable audit trail.' },
  { icon: Shield, title: 'HIPAA-Hardened', body: 'PHI-secured storage with automatic 5-minute signed URL expiration.' },
  { icon: UserCheck, title: 'Surgeon Sovereignty', body: 'The surgeon remains the sole clinical authority.' },
];

export function SecurityInvariantsSection() {
  return (
    <section className="py-20 md:py-28 bg-secondary">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-12 md:mb-14">
          <p className="text-xs font-semibold tracking-widest uppercase text-primary mb-4">
            Security &amp; Compliance
          </p>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-6">
            The LINK Invariants
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Non-negotiable guarantees baked into every layer of the platform.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {invariants.map((item) => (
            <Card key={item.title} className="bg-card border border-border rounded-xl transition-all hover:shadow-lg">
              <CardContent className="p-8">
                <div className="flex items-center justify-center w-9 h-9 rounded-lg bg-primary/10 border border-primary/20 mb-4">
                  <item.icon className="h-4 w-4 text-primary" strokeWidth={1.5} />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-3">{item.title}</h3>
                <p className="text-muted-foreground leading-relaxed">{item.body}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
